var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "詳細情報", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("FlightDataForm", {
              ref: "flightDataForm",
              attrs: {
                "label-width": "10em",
                formMode: "edit",
                "autocomplete-customer-code-set":
                  _vm.autocompleteCustomerCodeSet,
                "autocomplete-registration_symbol-set":
                  _vm.autocompleteRegistrationSymbolSet
              },
              model: {
                value: _vm.flightDataFormModel,
                callback: function($$v) {
                  _vm.flightDataFormModel = $$v
                },
                expression: "flightDataFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return undefined
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }